import React from "react";
import { Link } from "react-router-dom";
import FooterLogo from "../../assets/image/footerlogo.png";
import "./footer.styles.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationDot, faPhone, faFax, faEnvelopeOpen } from "@fortawesome/free-solid-svg-icons";
const Footer = () => {
  return (
    <div className="footer-content pt-5">
      <div className="container-fluid">
        <div className="footer-content__widgets">
          <div className="row ">
            <div className="col-12 col-md-4 mb-3">
              <div className="footer-content__widget footer-brand ">
                <Link to="/">
                  <img src={FooterLogo} alt="Footer Logo" className="img-fluid"/>
                </Link>
                {/* <p className="mt-5">Start saving your items quickly and easily. Organize and add items you need or an entire List to your cart with just a click for fast reordering.</p> */}
              </div>
            </div>

            {/* <div className="col-6 col-md-3 col-lg-2">
              <div className="footer-content__widget footer-links">
                <h5 className="footer-links__title">Information</h5>
                <ul className="footer-links__list">
                  <li className="footer-links__item">
                    <Link to="/" className="footer-links__link">
                      About Us
                    </Link>
                  </li>
                  <li className="footer-links__item">
                    <Link to="/" className="footer-links__link">
                      Delivery Information
                    </Link>
                  </li>
                  <li className="footer-links__item">
                    <Link to="/" className="footer-links__link">
                      Privacy Policy
                    </Link>
                  </li>
                  <li className="footer-links__item">
                    <Link to="/" className="footer-links__link">
                      Brands
                    </Link>
                  </li>
                  <li className="footer-links__item">
                    <Link to="/" className="footer-links__link">
                      Contact Us
                    </Link>
                  </li>
                  <li className="footer-links__item">
                    <Link to="/" className="footer-links__link">
                      Returns
                    </Link>
                  </li>
                  <li className="footer-links__item">
                    <Link to="/" className="footer-links__link">
                      Site Map
                    </Link>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-6 col-md-3 col-lg-2">
              <div className="footer-content__widget footer-links">
                <h5 className="footer-links__title">My Account</h5>
                <ul className="footer-links__list">
                  <li className="footer-links__item">
                    <Link to="/" className="footer-links__link">
                      Store Location
                    </Link>
                  </li>
                  <li className="footer-links__item">
                    <Link to="/" className="footer-links__link">
                      Order History
                    </Link>
                  </li>
                  <li className="footer-links__item">
                    <Link to="/" className="footer-links__link">
                      Wish List
                    </Link>
                  </li>
                  <li className="footer-links__item">
                    <Link to="/" className="footer-links__link">
                      Newsletter
                    </Link>
                  </li>
                  <li className="footer-links__item">
                    <Link to="/" className="footer-links__link">
                      Specials
                    </Link>
                  </li>
                  <li className="footer-links__item">
                    <Link to="/" className="footer-links__link">
                      Gift Certificates
                    </Link>
                  </li>
                  <li className="footer-links__item">
                    <Link to="/" className="footer-links__link">
                      Affiliate
                    </Link>
                  </li>
                </ul>
              </div>
            </div> */}

            <div className="col-12 col-md-4 mb-3">
              <div className="footer-content__widget footer-contacts">
                <ul className="footer-contacts__contacts">
                  <li className="bold">
                    <FontAwesomeIcon icon={faLocationDot} /> DCT Specialties, Inc
                  </li>
                  <li className="ml">15477 Woodrow Wilson</li>
                  <li className="ml">Detroit, MI 48238</li>
                  {/* <li>
                    <FontAwesomeIcon icon={faPhone} /> 855-420-7455
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faFax} /> 877-224-0918
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faEnvelopeOpen} /> customerservice@dctspecialties.com
                  </li> */}
                </ul>

                {/* <ul className="footer-contacts__socialIcons">
                  <li>
                    <FontAwesomeIcon icon={faFacebookSquare} />
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faTwitterSquare} />
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faGooglePlusSquare} />
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faInstagramSquare} />
                  </li>
                </ul> */}
              </div>
            </div>
            <div className="col-12 col-md-4 mb-3">
              <div className="footer-content__widget footer-contacts">
                <ul className="footer-contacts__contacts">
                  {/* <li>
                    <FontAwesomeIcon icon={faLocationDot} /> 15477 Woodrow Wilson Detroit, MI 48238 
                  </li> */}
                  <li>
                    <FontAwesomeIcon icon={faPhone} /> Tel: 855-420-7455
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faFax} /> Fax: 877-224-0918
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faEnvelopeOpen} /> Email: customerservice@dctspecialties.com
                  </li>
                </ul>

                {/* <ul className="footer-contacts__socialIcons">
                  <li>
                    <FontAwesomeIcon icon={faFacebookSquare} />
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faTwitterSquare} />
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faGooglePlusSquare} />
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faInstagramSquare} />
                  </li>
                </ul> */}
              </div>
            </div>
          </div>
          <div className="row  ">
            <div className="col-lg-12 p-2 copyright copyright_text">
              <p style={{ marginBottom: "0px" }}>1971- {new Date().getFullYear()} &copy; Diversified Chemical Technologies, Inc.All Rights Reserved.</p>
            </div>
          </div>
          <div className="row d-none">
            <div className="col-lg-12 copyright_txt">
              <p style={{ color: "gray" }}>
                
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
